import { api } from './client'

// The one search box (admin revamp, 31 Oct 2026): app/api/admin_search.py. Scoped by the server:
// platform admin everyone; school admin / principal their school; teacher the students of his grades.
export interface SearchHit {
  id: string
  name: string
  role: string
  grade_name?: string | null
  school_name?: string | null
  is_test: boolean
  matched: 'name' | 'email' | 'phone' | 'id'
}
export interface SearchResult {
  q: string
  students: SearchHit[]
  staff: SearchHit[]
}

export async function searchPeople(q: string): Promise<SearchResult> {
  const { data } = await api.get<SearchResult>('/admin/search', { params: { q } })
  return data
}
